import * as yup from "yup";
import i18n from "../../i18n";

const requiredMessage = () => i18n.t("validation.required", {ns: "common"});
const emailRequired = () => i18n.t("validation.emailRequired", {ns: "common"});

export const loginFormValidations = yup.object().shape({
    username: yup.string().required(requiredMessage),
    password: yup.string().required(requiredMessage)
});

export const forgotPasswordValidations = yup.object().shape({
    email: yup
        .string()
        .email(emailRequired)
        .required(requiredMessage)
});
